import React from 'react';

const FooterBXC = () => (
  <footer className="max-w-4xl mx-auto mt-4 text-xs text-gray-500 text-center border-t border-gray-200 pt-4 pb-4 px-4" style={{ background: 'rgba(255,255,255,0.7)', borderRadius: 12 }}>
    <div className="text-gray-400 text-sm">© {new Date().getFullYear()} BoletoXCrypto. Todos os direitos reservados.</div>
  </footer>
);

export default FooterBXC; 